export default __webpack_public_path__ + "static/media/Landscape-lg.2ca9d772.png";